import { Product3x2 } from "../modules/product3x2";

export const Product3x2Page = () => {
  return <Product3x2 />;
};
